
export const salute = [
    "SOFTWARE ENGINEER",
    "SOFTWARE DEVELOPER",
    "UNITY DEVELOPER",
    "REACT DEVELOPER"
    // "Welcome to my personal website, where technology meets creativity!",
    // "I am a Junior Software Engineer skilled in C# and JavaScript, eager to constantly learn and add skills to my toolbox and keep my knowledge up to date.",
    // "From the latest programming languages to the newest tech tools, I've got you covered, my dude. But it's not just about the tech, it's about creating things that makes people say, \"holy s**t, this is amazing!\" And that's what I strive for every damn day.",
    // "Listen, being a software engineer doesn't mean you have to be a boring son of a b**ch.", 
    // "Now keep scrolling...", 
    // "Go please...", 
    // "Comeeee on...", 
    // "For the love of God please keep scrolling, I really tried to build this website."
]

export const formMessage = "Our contact form is taking a nap. If you need to reach us, just yell really loudly, or just scan the QR code."